import { ChevronLeftIcon, LinkIcon, PaperAirplaneIcon, PencilIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import { Button } from '@/components/core/Button';
import { Icon } from '@/components/core/Icon';
import DownloadButton from '@/components/download-button/DownloadButton';
import { LOCAL_STORAGE } from '@/constants';
import { useToast } from '@/hooks/useToast';
import { useTranslation } from '@/hooks/useTranslation';
import { getInjector, getRootScope } from '@/services/angularjs-bridge';
import { logger } from '@/services/logger';

const ItemDetailsToolbar = ({
    primaryKey,
    startMappingEditor,
    startTemplateMappingSelector}: {
        primaryKey: string,
        startMappingEditor: any,
        startTemplateMappingSelector:any
    }) => {

    const $angularJSInjector = getInjector();
    const $rootScope = getRootScope($angularJSInjector);

    const { t } = useTranslation();
    const { toast } = useToast();
    const defaultShowReviewPanel = localStorage.getItem(LOCAL_STORAGE.SHOW_REVIEW_KEY);
    const [showReviewPanel, setShowReviewPanel] = useState<boolean>(defaultShowReviewPanel !== 'true');
    const onCopyItemLink = () => {
        // Get the base URL (protocol, host, and port)
        const { protocol, host, port } = window.location;
        let url = `${protocol}//${host}`;
        // Append port if necessary
        if (port && port !== '443') {
            url += `:${port}`;
        }
        url += `/items/detail/${primaryKey}`;
        navigator.clipboard.writeText(url).then(() => {
            toast.success('ONLINE_CATALOG.LINK_COPIED_TO_CLIPBOARD');
        }).catch((error) => {
            logger.error('Failed to copy text: ', error);
        });
    };

    const onEditItem = () => {
        const url = `/edit/${primaryKey}`;
        window.open(url, '_blank');
    };

    const showHideReviewPanel = function () {
        setShowReviewPanel(!showReviewPanel);
        localStorage.setItem(LOCAL_STORAGE.SHOW_REVIEW_KEY, showReviewPanel ? showReviewPanel.toString() : 'false');
        $rootScope.$broadcast('showReviewPanelChanged', showReviewPanel);
    };

    const onBackToCatalog = (e: React.MouseEvent) => {
        e.preventDefault();
        $rootScope.shouldRefreshCatalog = true;
        window.history.back();
    };

    return (<div className='tw-w-full tw-flex tw-justify-between tw-bg-white tw-mb-3'>
        <div className='tw-w-1/2 tw-p-4'>
            {/* back to catalog link */}
            <a href='/catalog' onClick={onBackToCatalog}>
                <Icon icon={ChevronLeftIcon} size='sm' variant='secondary' />
                <span className='tw-p-1'>{t('CATALOG.BACK')} </span>
            </a>
        </div>
        <div className='tw-flex tw-space-x-4 tw-w-1/2 tw-p-4 tw-justify-end'>
            {/* copy Item Link*/}
            <Button variant='outline' onClick={onCopyItemLink}>
                <Icon icon={LinkIcon} size='sm' variant='secondary' />
                <span className='tw-p-1'>{t('ONLINE_CATALOG.COPY_ITEM_LINK')}</span>
            </Button>
            {/* Download Item*/}
            <DownloadButton selectedItems={[primaryKey]} startMappingEditor={startMappingEditor} startTemplateMappingSelector={startTemplateMappingSelector}/>

            {/* Edit Item*/}
            <Button variant='outline' onClick={onEditItem}>
                <Icon icon={PencilIcon} size='sm' variant='secondary' />
                <span className='tw-p-1'>{t('ONLINE_CATALOG.EDIT_THIS_ITEM')}</span>
            </Button>

            {/* Review panel*/}
            <Button id="show-review-panel" variant='default' onClick={showHideReviewPanel}>
                <Icon icon={PaperAirplaneIcon} size='sm' variant='light' />
                <span className='tw-p-1'>{t(showReviewPanel ? 'ONLINE_CATALOG.SHOW_REVIEW_PANEL'
                    : 'ONLINE_CATALOG.HIDE_REVIEW_PANEL')}</span>
            </Button>

        </div>

    </div>);
};

export default ItemDetailsToolbar;
